(() => {
  const siteHeader = document.querySelector('.site-header');
  const toggle = document.querySelector('[data-header-search-toggle]');
  const panel = document.querySelector('[data-header-search-panel]');

  if (!siteHeader || !toggle || !panel) return;

  const panelInner = panel.querySelector('.header-search-panel__inner');
  const form = panel.querySelector('[data-header-search-form]');
  const input = panel.querySelector('[data-header-search-input]');
  const closeButton = panel.querySelector('[data-header-search-close]');
  const clearButton = panel.querySelector('[data-header-search-clear]');
  const resultsElement = panel.querySelector('[data-header-search-results]');
  const statusElement = panel.querySelector('[data-header-search-status]');
  const allResultsLink = panel.querySelector('[data-header-search-all]');
  const searchPath = form.getAttribute('action') || '/search';
  let requestController;
  let debounceTimer;
  let heightFrame;

  const syncPanelHeight = () => {
    if (!panelInner) return;
    panel.style.setProperty('--header-search-height', `${panelInner.scrollHeight}px`);
  };

  const queueHeightSync = () => {
    window.cancelAnimationFrame(heightFrame);
    heightFrame = window.requestAnimationFrame(syncPanelHeight);
  };

  const setOpen = (open) => {
    if (open) syncPanelHeight();
    siteHeader.classList.toggle('search-is-open', open);
    panel.classList.toggle('is-open', open);
    panel.setAttribute('aria-hidden', String(!open));
    panel.inert = !open;
    toggle.setAttribute('aria-expanded', String(open));
    input.setAttribute('aria-expanded', String(open && resultsElement.children.length > 0));

    if (open) {
      window.requestAnimationFrame(() => input.focus());
    }
  };

  const resetResults = (message = 'Start typing to see matching products and pages.') => {
    resultsElement.replaceChildren();
    resultsElement.removeAttribute('aria-busy');
    input.setAttribute('aria-expanded', 'false');
    statusElement.textContent = message;
    statusElement.hidden = false;
    allResultsLink.hidden = true;
    queueHeightSync();
  };

  const renderResults = (markup, query) => {
    const documentFragment = new DOMParser().parseFromString(markup, 'text/html');
    const fragment = documentFragment.querySelector('[data-predictive-search-fragment]');
    const matches = fragment?.querySelectorAll('.header-search-result') || [];
    resultsElement.replaceChildren();
    resultsElement.removeAttribute('aria-busy');

    if (matches.length === 0) {
      resetResults(`No quick matches for “${query}”. Press Enter to search the full store.`);
      return;
    }

    matches.forEach((match) => resultsElement.append(document.importNode(match, true)));

    statusElement.hidden = true;
    input.setAttribute('aria-expanded', 'true');
    allResultsLink.href = `${searchPath}?q=${encodeURIComponent(query)}&options%5Bprefix%5D=last`;
    allResultsLink.hidden = false;
    queueHeightSync();
  };

  const fetchResults = async (query) => {
    requestController?.abort();
    requestController = new AbortController();
    resultsElement.setAttribute('aria-busy', 'true');
    statusElement.textContent = 'Searching…';
    statusElement.hidden = false;

    const root = window.Shopify?.routes?.root || '/';
    const endpoint = new URL(`${root}search/suggest`, window.location.origin);
    endpoint.searchParams.set('q', query);
    endpoint.searchParams.set('resources[type]', 'product,collection,page,article');
    endpoint.searchParams.set('resources[limit]', '8');
    endpoint.searchParams.set('resources[options][unavailable_products]', 'last');
    endpoint.searchParams.set('section_id', 'predictive-search');

    try {
      const response = await fetch(endpoint, {
        signal: requestController.signal
      });

      if (!response.ok) throw new Error(`Predictive search returned ${response.status}`);
      renderResults(await response.text(), query);
    } catch (error) {
      if (error.name === 'AbortError') return;
      resetResults('Quick results are unavailable. Press Enter to search the full store.');
    }
  };

  toggle.addEventListener('click', () => {
    setOpen(!panel.classList.contains('is-open'));
  });

  closeButton.addEventListener('click', () => {
    setOpen(false);
    toggle.focus();
  });

  clearButton.addEventListener('click', () => {
    input.value = '';
    clearButton.hidden = true;
    resetResults();
    input.focus();
  });

  input.addEventListener('input', () => {
    window.clearTimeout(debounceTimer);
    const query = input.value.trim();
    clearButton.hidden = query.length === 0;

    if (query.length < 2) {
      requestController?.abort();
      resetResults(query.length === 1 ? 'Type one more character to search.' : undefined);
      return;
    }

    debounceTimer = window.setTimeout(() => fetchResults(query), 180);
  });

  form.addEventListener('submit', (event) => {
    if (!input.value.trim()) {
      event.preventDefault();
      input.focus();
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && panel.classList.contains('is-open')) {
      setOpen(false);
      toggle.focus();
    }
  });

  document.addEventListener('click', (event) => {
    if (panel.classList.contains('is-open') && !siteHeader.contains(event.target)) {
      setOpen(false);
    }
  });

  window.addEventListener('resize', queueHeightSync, { passive: true });
  if ('ResizeObserver' in window && panelInner) {
    new ResizeObserver(queueHeightSync).observe(panelInner);
  }
  syncPanelHeight();
})();
